import React  from "react";
import ProfileCard from "../../../shared-components/ProfileCard/ProfileCard";
import CategoryItem from "../../../shared-components/CategoryItem/CategoryItem";
import { AnimationFileLoader } from '../../../utilis/animation-loader'; // Adjust the path
import {NavLink } from "react-router-dom";

//    <link rel="stylesheet" to="./plugins/nice-select/nice-select.css" />

function Collection() {
    AnimationFileLoader();

    return (
      <>


      {/* Author */}
    <div className="author-area">
        <div className="author-cover" data-bg-img="/img/bg/author-cover.png"></div>
    </div>
    {/* End Author */}

    {/* Author Profile */}
    <section className="pt-120 pb-120">
        <div className="container">
            <div className="row mb-50">
                <div className="col-lg-9 order-1 order-lg-0">
                    {/* Tab Buttons */}
                    <ul className="nav tab-buttons justify-content-center justify-content-lg-start">
                        <li>
                            <button className="active select-rounded text-uppercase lg" data-bs-toggle="tab"
                                data-bs-target="#collected">On Sale</button>
                        </li>
                        <li>
                            <button className="select-rounded text-uppercase lg" data-bs-toggle="tab"
                                data-bs-target="#created">Creations</button>
                        </li>
                        <li>
                            <button className="select-rounded text-uppercase lg" data-bs-toggle="tab"
                                data-bs-target="#favorited">Collections</button>
                        </li>
                    </ul>
                    {/* End Tab Buttons */}
                </div>
                <div className="col-lg-3 order-0 order-lg-1">
                    <div className="d-flex justify-content-center justify-content-lg-end mb-4 mb-lg-0">
                        <select className="select-rounded lg">
                            <option value="offers">Recent Active</option>
                            <option value="offers_received">Year 2016</option>
                            <option value="offers_made">Year 2017</option>
                        </select>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-lg-8 mb-60 mb-lg-0">
                    <div className="tab-content">
                        <div className="tab-pane fade show active" id="collected">
                            <div className="row">
                                <div className="col-md-6">
                                    {/* Category */}
                                    <NavLink to="explore.html" className="category-item mb-30">
                                        <img src="/img/media/cat1.png" alt=""/>

                                        <div className="content">
                                            <img src="/img/media/cat-s1.png" alt=""/>
                                            <h5>Art Painting</h5>
                                        </div>
                                    </NavLink>
                                    {/* End Category */}
                                </div>
                                <div className="col-md-6">
                                    {/* Category */}
                                    <NavLink to="explore.html" className="category-item mb-30">
                                        <img src="/img/media/cat2.png" alt=""/>

                                        <div className="content">
                                            <img src="/img/media/cat-s2.png" alt=""/>
                                            <h5>Trading Painting</h5>
                                        </div>
                                    </NavLink>
                                    {/* End Category */}
                                </div>
                                <div className="col-md-6">
                                    {/* Category */}
                                    <NavLink to="explore.html" className="category-item mb-30">
                                        <img src="/img/media/cat3.png" alt=""/>

                                        <div className="content">
                                            <img src="/img/media/cat-s3.png" alt=""/>
                                            <h5>Virtual Painting</h5>
                                        </div>
                                    </NavLink>
                                    {/* End Category */}
                                </div>
                                <div className="col-md-6">
                                    {/* Category */}
                                    <NavLink to="explore.html" className="category-item mb-30">
                                        <img src="/img/media/cat4.png" alt=""/>

                                        <div className="content">
                                            <img src="/img/media/cat-s4.png" alt=""/>
                                            <h5>Liquid Forest</h5>
                                        </div>
                                    </NavLink>
                                    {/* End Category */}
                                </div>
                                <div className="col-lg-12 d-flex justify-content-center mt-30">
                                    <NavLink to="#" className="btn"><img src="/img/icons/btn-loadmore.svg" alt=""
                                            className="svg"/>
                                        Load
                                        More</NavLink>
                                </div>
                            </div>
                        </div>
                        <div className="tab-pane fade" id="created">
                            <div className="row">
                                <div className="col-md-6">
                                    {/* Category */}
                                    <NavLink to="explore.html" className="category-item mb-30">
                                        <img src="/img/media/cat2.png" alt=""/>

                                        <div className="content">
                                            <img src="/img/media/cat-s2.png" alt=""/>
                                            <h5>Trading Painting</h5>
                                        </div>
                                    </NavLink>
                                    {/* End Category */}
                                </div>
                                <div className="col-md-6">
                                    {/* Category */}
                                    <NavLink to="explore.html" className="category-item mb-30">
                                        <img src="/img/media/cat1.png" alt=""/>

                                        <div className="content">
                                            <img src="/img/media/cat-s1.png" alt=""/>
                                            <h5>Art Painting</h5>
                                        </div>
                                    </NavLink>
                                    {/* End Category */}
                                </div>
                                <div className="col-md-6">
                                    {/* Category */}
                                    <NavLink to="explore.html" className="category-item mb-30">
                                        <img src="/img/media/cat3.png" alt=""/>

                                        <div className="content">
                                            <img src="/img/media/cat-s3.png" alt=""/>
                                            <h5>Virtual Painting</h5>
                                        </div>
                                    </NavLink>
                                    {/* End Category */}
                                </div>
                                <div className="col-md-6">
                                    {/* Category */}
                                    <NavLink to="explore.html" className="category-item mb-30">
                                        <img src="/img/media/cat4.png" alt=""/>

                                        <div className="content">
                                            <img src="/img/media/cat-s4.png" alt=""/>
                                            <h5>Liquid Forest</h5>
                                        </div>
                                    </NavLink>
                                    {/* End Category */}
                                </div>
                                <div className="col-lg-12 d-flex justify-content-center mt-30">
                                    <NavLink to="#" className="btn"><img src="/img/icons/btn-loadmore.svg" alt=""
                                            className="svg"/>
                                        Load
                                        More</NavLink>
                                </div>
                            </div>
                        </div>
                        <div className="tab-pane fade" id="favorited">
                            <div className="row">
                                <div className="col-md-6">
                                    {/* Category */}
   

                                    
                                    <CategoryItem
                      coverImgSrc="/img/media/cat3.png"
                      subImgSrc="/img/media/cat-s3.png"
                      heading="Art Painting"
                    />
                                    {/* End Category */}
                                </div>
                                <div className="col-md-6">
                                    {/* Category */}
\

                                    <CategoryItem
                      coverImgSrc="/img/media/cat3.png"
                      subImgSrc="/img/media/cat-s3.png"
                      heading="Liquid Forest"
                    />
                                    {/* End Category */}
                                </div>
                                <div className="col-md-6">
                                    {/* Category */}

                                    <CategoryItem
                      coverImgSrc="/img/media/cat3.png"
                      subImgSrc="/img/media/cat-s3.png"
                      heading="Trading Painting"
                    />
                                    {/* End Category */}
                                </div>
                                <div className="col-md-6">
                                    {/* Category */}

                                    <CategoryItem
                      coverImgSrc="/img/media/cat3.png"
                      subImgSrc="/img/media/cat-s3.png"
                      heading="Virtual Painting"
                    />

                                    {/* End Category */}
                                </div>
                                <div className="col-lg-12 d-flex justify-content-center mt-30">
                                    <NavLink to="#" className="btn"><img src="/img/icons/btn-loadmore.svg" alt=""
                                            className="svg"/>
                                        Load
                                        More</NavLink>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4">
                    {/* Author Sidebar */}
                    <div className="author-sidebar">
                    <ProfileCard
                  avatarImgSrc="/img/media/profile-avatar.png"
                  statusImgSrc="/img/icons/check-white.svg"
                  authorName="AneftyPunks"
                  code="69b9ebde0178k7O7&exportsw"
                  facebookLink="https://www.facebook.com/"
                  twitterLink="https://www.twitter.com/"
                  instagramLink="https://www.Instagram.com/"
                  linkedinLink="https://www.linkedin.com/"
                />
                    </div>
                    {/* End Author Sidebar */}
                </div>
            </div>
        </div>
    </section>
    {/* End Author Profile */}

    </>
  );
}

export default Collection;
